import classNames from "classnames";
import styles from "./Card.module.css";
import React, { FC } from "react";
import classnames from "classnames";
import { PictureOrVideo } from "components/atoms";
import { motion } from "framer-motion";
import { months } from "./meta";
import he from "he";

type TRelatedContentCardProps = {
    className?: string;
    tileWidth?: string;
    id: string;
    Url: string;
    index: number;
    HeroSectionImage1: { Src: string, Alt: string };
    LargeBlockImage: { Src: string, Alt: string };
    isDesktop: boolean;
    Title?: string;
    Abstracts?: boolean;
    Abstract?: string;
    MetaHeading?: string;
    ReadTime?: string;
    PublicationDate?: string;
    ShowPublicationDateReadTimeContentType?: boolean;
    ContentType?: null | { [key: string]: string };
    FeaturedText?: string | null
}

export const RelatedContentCard: FC<TRelatedContentCardProps> = ({
    ContentType,
    ShowPublicationDateReadTimeContentType,
    PublicationDate,
    ReadTime,
    className,
    id,
    Url,
    index,
    HeroSectionImage1,
    LargeBlockImage,
    isDesktop,
    Title,
    Abstracts,
    Abstract,
    MetaHeading,
    FeaturedText
}) => {

    const timeStamp = PublicationDate?.match(/[\d]+/)[0];
    const date = timeStamp && new Date(parseInt(timeStamp));
    const dateFormatted = date && `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;

    const publicationDateReadTimeContentTypeNode = <motion.span>{PublicationDate && dateFormatted}{ReadTime && (' | ' + ReadTime + ' min read')}{Boolean(ContentType) && (' | ' + ContentType.ContentTypeName)}</motion.span>;

    return (
        <div key={id} 
        className={classNames(styles.item, className)}
        onClick={() => window.location.replace(Url)}
        >
            <div
                key={`item-${index}`}
                className={classNames(styles.item)}
            >
                {(HeroSectionImage1 || LargeBlockImage) && (
                    <PictureOrVideo
                        specifySize={{ width: isDesktop ? 40 : 100, x: isDesktop ? 1 : 2 }}
                        src={Boolean(HeroSectionImage1?.Src) ? HeroSectionImage1?.Src : LargeBlockImage?.Src}
                        alt={Boolean(HeroSectionImage1?.Alt) ? HeroSectionImage1?.Alt : LargeBlockImage?.Alt}
                        className={classnames(styles.img, 'scale')}
                    />
                )}
                {Boolean(FeaturedText) ?
                    <p className="featured-series-label">{he.decode(FeaturedText)}</p>
                    :
                    ShowPublicationDateReadTimeContentType && publicationDateReadTimeContentTypeNode
                }
                {Title && <h3 dangerouslySetInnerHTML={{ __html: Title }}></h3>}
                {Abstracts && Abstract && (
                    <p dangerouslySetInnerHTML={{ __html: Abstract }}></p>
                )}
            </div>
        </div>
    )
};
